import React, { createContext, useState, ReactNode, useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { BRAND } from '../theme/brand';

interface ThemeContextType {
  darkMode: boolean;
  toggleDarkMode: () => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [darkMode, setDarkMode] = useState(true);

  const toggleDarkMode = () => setDarkMode((prev) => !prev);

  // MUI téma a Csillagtanoda arculati színeivel (lila átmenet + sárga), a darkMode-tól függően
  const muiTheme = useMemo(() => createTheme({
    palette: {
      mode: darkMode ? 'dark' : 'light',
      primary: darkMode
        ? { main: BRAND.yellow, contrastText: BRAND.onYellow }   // sötét módban sárga kiemelés
        : { main: BRAND.purple, contrastText: '#ffffff' },       // világos módban lila kiemelés
      secondary: darkMode
        ? { main: BRAND.purpleLight, contrastText: '#ffffff' }
        : { main: BRAND.purpleLight, contrastText: '#ffffff' },
      background: darkMode
        ? { default: BRAND.purpleDark, paper: '#1d1247' }
        : { default: '#F7F0F9', paper: '#ffffff' },
    },
    typography: {
      fontFamily: "Montserrat, sans-serif",
    },
    components: {
      // Az oldal háttere: sötét módban a lila átmenet, világos módban halvány lila
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            background: darkMode ? BRAND.gradient : '#F7F0F9',
            backgroundAttachment: 'fixed',
            minHeight: '100vh',
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: { textTransform: 'none', fontWeight: 700 },
        },
      },
    },
  }), [darkMode]);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <MuiThemeProvider theme={muiTheme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};